import React from "react";

export default () => {
  return (
    <svg
      id="Gruppe_7927"
      data-name="Gruppe 7927"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="29.967"
      height="30"
      viewBox="0 0 29.967 30"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rechteck_7635"
            data-name="Rechteck 7635"
            width="29.967"
            height="30"
            transform="translate(0 0)"
            fill="#80858c"
          />
        </clipPath>
      </defs>
      <g
        id="Gruppe_7926"
        data-name="Gruppe 7926"
        transform="translate(0 0)"
        clip-path="url(#clip-path)"
      >
        <path
          id="Pfad_6689"
          data-name="Pfad 6689"
          d="M10.7,30a1.013,1.013,0,0,1-.695-1.092c.063-2.165.042-4.334.193-6.492a31.143,31.143,0,0,1,1.94-9.207,1.407,1.407,0,0,0,.04-.164c-.112-.007-.2-.017-.3-.017-.79,0-1.581-.013-2.371,0a.994.994,0,0,1-.959-.541c-.195-.337-.407-.663-.632-1.026-.228.368-.444.7-.645,1.043a.99.99,0,0,1-.939.524c-1.8-.01-3.591,0-5.387,0a.874.874,0,0,1-.926-1.132A8.007,8.007,0,0,1,6.892,5.456.569.569,0,0,0,6.98,5.42c-.069-.077-.127-.148-.191-.212Q5.63,4.048,4.471,2.889a.894.894,0,0,1,.157-1.517,8.029,8.029,0,0,1,10.131.993c.068.067.138.131.168.159a18.246,18.246,0,0,1,1.847-1.361,7.858,7.858,0,0,1,8.6.244A.879.879,0,0,1,25.5,2.869q-1.156,1.162-2.318,2.319c-.067.067-.13.139-.219.234.341.068.656.11.959.193A7.957,7.957,0,0,1,29.9,11.723a1.791,1.791,0,0,0,.068.183v.468a1.093,1.093,0,0,1-1.143.661c-3.59-.018-7.18-.008-10.77-.013-.208,0-.3.042-.342.273a30.5,30.5,0,0,0-.126,9.121,53.446,53.446,0,0,0,1.129,6.267A.955.955,0,0,1,18.139,30Zm5.264-16.973c-.54,0-1.047.012-1.552-.006a.366.366,0,0,0-.41.264,26.272,26.272,0,0,0-1.718,6.327,50.344,50.344,0,0,0-.53,8.367c0,.084.011.167.017.245H16.8c-1.067-5.024-1.7-10.052-.832-15.2m.193-1.774H27.905a6.225,6.225,0,0,0-5.959-4.109,6.294,6.294,0,0,0-5.787,4.109m-2.357.017a6.252,6.252,0,0,0-11.751-.017,1.259,1.259,0,0,0,.139.017c1.2,0,2.4,0,3.6-.007a.416.416,0,0,0,.29-.173c.36-.556.7-1.125,1.052-1.687a.884.884,0,0,1,1.585.006c.347.553.684,1.113,1.036,1.662.054.085.166.19.251.19,1.257.012,2.515.008,3.8.008m1.189-1.689a2.255,2.255,0,0,0,.317-.71,9.367,9.367,0,0,0-.076-2.034A6.248,6.248,0,0,0,8.16,1.845a5.266,5.266,0,0,0-1.7.521,1.349,1.349,0,0,0,.086.108c.993.994,1.984,1.99,2.984,2.977a.785.785,0,0,0,.354.178,7.869,7.869,0,0,1,2.276.969,8.2,8.2,0,0,1,2.838,2.983m2.084-2.516a.8.8,0,0,0,.126-.059,8.26,8.26,0,0,1,2.964-1.4.734.734,0,0,0,.312-.195c.852-.844,1.7-1.7,2.548-2.542.157-.156.326-.3.514-.472-.1-.054-.136-.08-.178-.1a6.309,6.309,0,0,0-7.187,1.586c-.116.135-.076.223-.023.359.27.7.533,1.4.779,2.1a5.28,5.28,0,0,1,.145.723M19.227,20.8a6.273,6.273,0,0,1,.793-2.845,12.6,12.6,0,0,1,2.054-2.869.85.85,0,0,1,1.275-.028,11.307,11.307,0,0,1,2.607,4.153,4.568,4.568,0,0,1,.124,2.707A3.513,3.513,0,0,1,19.227,20.8m3.519-3.774A7.765,7.765,0,0,0,21.028,20.3a1.734,1.734,0,0,0,1.936,2.273A1.7,1.7,0,0,0,24.438,20.4a7.923,7.923,0,0,0-1.692-3.38"
          transform="translate(0 0)"
          fill="#80858c"
        />
      </g>
    </svg>
  );
};
